var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappPositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 681.6 725.6",
    style: {
      enableBackground: "new 0 0 681.6 725.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M637.3,183.9C565.9,52.1,418.8-17.5,273.5,12C54.2,56.7-60.9,300.8,44.3,499.1c8.2,15.3,9.6,28.8,5.3,45.1 C34.3,601.8,20.5,659.7,4.8,722.6c58.3-26.3,111.9-50.5,165.6-75.3c10.3-4.6,18.8-5.3,29.8-0.4c133.6,59,277.5,33,378.4-68.2 C682.4,474.6,707,312.6,637.3,183.9z M599.3,411.4c-29.5,109.1-104.1,175.5-215.7,195.8c-67.5,12.4-131.8-2.5-189.7-40.2 c-9.6-6.4-16-5.7-25.2,0.4c-20.6,13.9-41.6,26.6-62.5,40.2c-1.1-0.7-2.1-1.1-3.2-1.8c8.9-22.4,16.7-45.1,26.3-67.2 c6.4-14.2,5-24.9-4.6-38c-99.8-134.3-52.9-328,98.1-399.7c101.6-48.3,200.8-38,287.8,33.4C597.9,206,629.1,301.9,599.3,411.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.1,408.5c-5.3-2.5-10.7-5-16-7.5c-39.8-18.8-40.2-19.2-70.4,13.5c-8.9,9.6-18.1,13.1-29.8,7.5 c-43.4-20.6-77.8-51.5-100.9-93.8c-2.8-5.3-2.1-17.4,1.4-20.6c25.9-22.4,21.3-46.9,7.1-72.8c-3.6-6.8-6-14.2-8.9-21.3 c-10.7-26.3-40.2-31.3-60.1-10.3c-29.8,32-35.2,68.6-18.8,108.4c27.7,66.8,75.3,116.5,135.7,154.9c31.3,19.9,64,36.2,102.3,35.9 c27.4,0,51.5-11.4,70-32.7C519.3,448.3,514,420.9,489.1,408.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappPositive);
export default __webpack_public_path__ + "static/media/whatsapp-positive.aa955da631b16d784092ac9e7d5af1d2.svg";
export { ForwardRef as ReactComponent };